<ng-container *ngIf="!isMobileApp">
  <shrd-pf-ft-header-logged-mode class="d-print-none" />
  <div
    *shrdUtcLet="isCompressed$ | async as isCompressed"
    class="container-fluid my-auto header-strip-wrapper d-print-none"
    [class.is-compressed]="isCompressed"
  >
    <div *ngIf="userData" class="row w-100 w-md-auto">
      <ng-container *ngTemplateOutlet="isCompressed ? compressedHeaderTpl : fullHeaderTpl" />
    </div>
  </div>
  <ng-container *shrdUtcFeatureToggleOn="'ldt_ngc_hdms_print_header_footer'">
    <shrd-ft-header-print-layout *shrdUtcIfPlatformBrowser />
  </ng-container>
</ng-container>

<shrd-pf-ft-contact-modal [userData]="userData" />

<ng-template #fullHeaderTpl>
  <ng-container *ngIf="isDesktop">
    <div class="col-24 d-none d-md-block meta-nav" (focusin)="$event.target === skipMain && expandHeader(false)">
      <a
        href="#main"
        #skipMain
        shrdUicButton
        variant="secondary"
        class="visually-hidden-focusable position-absolute ms-3 mb-0"
      >
        {{ 'header.meta.skipMainLabel' | i18next }}
      </a>
      <div class="content-box d-flex justify-content-end pt-1" [class.search-input-focus]="searchComponent.hasFocus">
        <ng-container *ngTemplateOutlet="desktopUserWrapperTpl" />
        <ng-container *ngTemplateOutlet="manageMyToolsPopoverTpl" />
        <ng-container *ngTemplateOutlet="langPopoverTpl" />
        <shrd-pf-ft-meta-popover
          *ngIf="metaNavItemsMap[metaMenuType.CURRENCY] as currencyItem"
          [navItem]="currencyItem"
          [qaId]="'header-currency-selector'"
          flyoutClass="flyout-fixed-width"
        >
          <shrd-pf-ft-select-currency [inContentBox]="true" />
        </shrd-pf-ft-meta-popover>
        <ng-container *ngTemplateOutlet="contactPopoverTpl" />
        <shrd-pf-ft-header-cart
          *ngIf="metaNavItemsMap[metaMenuType.CART] as cartItem"
          [title]="cartItem.title"
          [trackingName]="cartItem.trackingName"
          btnClasses="my-0"
        />
        <shrd-pf-ft-search-popover
          #searchComponent
          class="position-relative d-flex ms-3 ms-lg-4"
          (searchFocused)="handleSearchFocus($event)"
        />
      </div>
    </div>
    <div class="col-24 d-none d-md-block" #primaryNav>
      <div class="content-box content-box-tertiary-left-sm-max d-flex py-1">
        <shrd-pf-ui-logo />
        <div class="nav-wrapper">
          <shrd-pf-ft-mega-menu class="primary-nav d-none d-md-inline-flex" [primaryNavItems]="primaryNavItems" />
          <button
            #btn
            shrdUicButton
            variant="tertiaryMinorBorderless"
            class="m-0 btn-show-nav"
            (click)="expandHeader(); btn.blur()"
            [attr.aria-label]="'header.icon.hamburger' | i18next"
          >
            <shrd-uic-svg-icon [icon]="iconName.HAMBURGER" size="small" [inheritColor]="true" />
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isMobile">
    <div class="col-12 d-md-none">
      <div class="content-box content-box-tertiary-left-sm-max d-flex">
        <ng-container *ngTemplateOutlet="burgerMenuWrapperTpl" />
        <shrd-pf-ui-logo />
      </div>
    </div>
    <div class="col-12 d-md-none">
      <div class="content-box content-box-tertiary-right d-flex justify-content-end header-meta-nav-mobile-wrapper">
        <ng-container *ngTemplateOutlet="mobileUserWrapperTpl" />
        <shrd-pf-ft-header-cart
          *ngIf="metaNavItemsMap[metaMenuType.CART] as cartItem"
          [btnVariant]="'tertiaryMinorBorderless'"
          [title]="cartItem.title"
          [trackingName]="cartItem.trackingName"
          btnClasses="m-0 icon-count-indicator--top-reset"
        />
        <shrd-pf-ft-search-mobile />
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #compressedHeaderTpl>
  <ng-container *ngIf="isDesktop">
    <div class="col-24 d-none d-md-block">
      <div class="content-box content-box-tertiary-right d-flex py-1">
        <shrd-pf-ui-logo />
        <div class="d-flex flex-row content-col-right">
          <ng-container *ngTemplateOutlet="desktopUserWrapperTpl" />
          <ng-container *ngTemplateOutlet="langPopoverTpl" />
          <ng-container *ngTemplateOutlet="contactPopoverTpl" />
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isMobile">
    <div class="col-12 d-md-none">
      <div class="content-box content-box-tertiary-left-sm-max d-flex">
        <ng-container *ngTemplateOutlet="burgerMenuWrapperTpl" />
        <shrd-pf-ui-logo />
      </div>
    </div>
    <div class="col-12 d-md-none">
      <div class="content-box content-box-tertiary-right d-flex justify-content-end header-meta-nav-mobile-wrapper">
        <ng-container *ngTemplateOutlet="mobileUserWrapperTpl" />
        <button
          *ngIf="metaNavItemsMap[metaMenuType.LANG] as languageMenuItem"
          shrdUicButton
          variant="tertiaryMinorBorderless"
          class="m-0"
          [attr.aria-label]="languageMenuItem.title"
          (click)="burgerMenuWrapper.openSecondaryMenu(languageMenuItem)"
        >
          <shrd-uic-svg-icon [icon]="languageMenuItem.icon" [inheritColor]="true" />
        </button>
        <button
          *ngIf="metaNavItemsMap[metaMenuType.CONTACT] as contactMenuItem"
          shrdUicButton
          variant="tertiaryMinorBorderless"
          class="m-0"
          [attr.aria-label]="contactMenuItem.title"
          (click)="burgerMenuWrapper.openSecondaryMenu(contactMenuItem)"
        >
          <shrd-uic-svg-icon [icon]="contactMenuItem.icon" [inheritColor]="true" />
        </button>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #desktopUserWrapperTpl>
  <shrd-pf-ft-user-wrapper [userData]="userData" [loggedUserTemplateRef]="loggedUserTpl">
    <ng-template #loggedUserTpl>
      <shrd-pf-ft-user-popover [userData]="userData" [contentRef]="popoverContent">
        <ng-template #popoverContent>
          <shrd-pf-ft-user-popover-content [userData]="userData" [logoutConfig]="logoutConfig$ | async" />
        </ng-template>
      </shrd-pf-ft-user-popover>
    </ng-template>
  </shrd-pf-ft-user-wrapper>
</ng-template>

<ng-template #mobileUserWrapperTpl>
  <shrd-pf-ft-user-wrapper [userData]="userData" [loggedUserTemplateRef]="loggedMobileTpl">
    <ng-template #loggedMobileTpl>
      <button
        shrdUicButton
        variant="tertiaryMinorBorderless"
        class="m-0"
        [ngClass]="{ 'text-primary': !userData.isRegistered }"
        [attr.aria-label]="'header.icon.profile' | i18next"
        (click)="burgerMenuWrapper.openMenuFromAccount()"
        [shrdUtcTrackEvent]="{ category: 'SiteOperations', action: 'UserAccountFlyout', label: 'Open' }"
      >
        <shrd-uic-svg-icon [icon]="iconName.PROFILE" [inheritColor]="true" />
      </button>
    </ng-template>
  </shrd-pf-ft-user-wrapper>
</ng-template>

<ng-template #manageMyToolsPopoverTpl>
  <ng-container *shrdUtcFeatureToggleOn="'ldt_hdms_header_manage_my_tools'">
    <shrd-pf-ft-meta-popover
      [navItem]="metaNavItemManageMyTools"
      flyoutClass="flyout-fixed-width px-3"
      [qaId]="'header-manage-my-tools-selector'"
      buttonCustomMaxWidth="145px"
    >
      <shrd-pf-ft-manage-my-tools />
    </shrd-pf-ft-meta-popover>
  </ng-container>
</ng-template>

<ng-template #langPopoverTpl>
  <shrd-pf-ft-meta-popover
    *ngIf="metaNavItemsMap[metaMenuType.LANG] as langItem"
    [navItem]="langItem"
    flyoutClass="flyout-fixed-width"
    [qaId]="'header-language-selector'"
  >
    <shrd-pf-ft-select-language [inContentBox]="true" />
  </shrd-pf-ft-meta-popover>
</ng-template>

<ng-template #contactPopoverTpl>
  <shrd-pf-ft-meta-popover
    *ngIf="metaNavItemsMap[metaMenuType.CONTACT] as contactItem"
    [navItem]="contactItem"
    flyoutClass="contact-popover"
    [qaId]="'header-contact-button'"
    #contactPopover
  >
    <shrd-pf-ft-contact-popover-content *ngIf="contactPopover.isOpen" [userData]="userData" />
  </shrd-pf-ft-meta-popover>
</ng-template>

<ng-template #burgerMenuWrapperTpl>
  <shrd-pf-ft-burger-menu-wrapper
    [metaNavItems]="metaNavItems"
    [primaryNavItems]="primaryNavItems"
    [userData]="userData"
    [logoutConfig]="logoutConfig$ | async"
  />
</ng-template>

<shrd-uic-modal
  *ngIf="tabAccountChanged$ | async"
  [title]="'header.account.messageChanged.title' | i18next"
  size="sm"
  [closeDisabled]="true"
  [autoOpen]="true"
  [bodyRef]="modalBodyTpl"
  [footerRef]="modalFooterTpl"
>
  <ng-template #modalBodyTpl>
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="col-24">
          <div class="content-box text-center">
            <img [src]="'/assets/images/completion-account-error.svg' | assetPath" alt="" />
            <p class="mt-2 mb-0">{{ 'header.account.messageChanged.copy1' | i18next }}</p>
            <p>{{ 'header.account.messageChanged.copy2' | i18next }}</p>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #modalFooterTpl>
    <div></div>
  </ng-template>
</shrd-uic-modal>
